import { HubEvents } from "../common/HubEventsEnum";
import { GridBaseModel, IGridBaseModel } from "../common/GridBaseModel";

export class AudiencesHub extends GridBaseModel implements IGridBaseModel {
  hubName: string = "audiences";

  constructor() {
    super("audiences");
  }

  onLoadData = callback => this.registerIncomingEvent(HubEvents.ON_LOAD_AUDIENCE_DATA, callback);

  invokeLoadData = async (organisationId: number, projectId: number) => {
    if (!this.isConnectionStarted) return;
    await this.connection.invoke(HubEvents.INVOKE_LOAD_AUDIENCE_DATA, {
      organisationId: organisationId,
      projectId: projectId
    });
  };
}

const instance = new AudiencesHub();
export default instance;
